














 





























const node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "kind": "Variable",
  "name": "teamId",
  "variableName": "teamId"
},
v3 = [
  (v2/*: any*/),
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "preferredName",
  "storageKey": null
},
v5 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "TeamMemberIntegrations",
  "kind": "LinkedField",
  "name": "integrations",
  "plural": false,
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useIsIntegrated_integrations"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TaskFooterIntegrateMenuSignup_TeamMemberIntegrations"
    }
  ],
  "storageKey": null
},
v7 = [
  (v2/*: any*/)
],
v8 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isActive",
    "storageKey": null
  },
  (v1/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "TeamMemberIntegrationAuthOAuth2",
  "kind": "LinkedField",
  "name": "auth",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "TeamMemberIntegrations",
  "kind": "LinkedField",
  "name": "integrations",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "JiraServerIntegration",
      "kind": "LinkedField",
      "name": "jiraServer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TeamMemberIntegrationAuthOAuth1",
          "kind": "LinkedField",
          "name": "auth",
          "plural": false,
          "selections": (v8/*: any*/),
          "storageKey": null
        },
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AtlassianIntegration",
      "kind": "LinkedField",
      "name": "atlassian",
      "plural": false,
      "selections": (v8/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GitHubIntegration",
      "kind": "LinkedField",
      "name": "github",
      "plural": false,
      "selections": (v8/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GitLabIntegration",
      "kind": "LinkedField",
      "name": "gitlab",
      "plural": false,
      "selections": [
        (v9/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "IntegrationProviderOAuth2",
          "kind": "LinkedField",
          "name": "cloudProvider",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v10/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serverBaseUrl",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AzureDevOpsIntegration",
      "kind": "LinkedField",
      "name": "azureDevOps",
      "plural": false,
      "selections": [
        (v9/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "IntegrationProviderOAuth2",
          "kind": "LinkedField",
          "name": "cloudProvider",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v10/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tenantId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TaskFooterIntegrateMenuQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": "assigneeTeamMember",
            "args": (v3/*: any*/),
            "concreteType": "TeamMember",
            "kind": "LinkedField",
            "name": "teamMember",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": (v5/*: any*/),
                "concreteType": "RepoIntegrationQueryPayload",
                "kind": "LinkedField",
                "name": "prevUsedRepoIntegrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "prevUsedRepoIntegrations(first:1)"
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "viewerTeamMember",
            "args": (v7/*: any*/),
            "concreteType": "TeamMember",
            "kind": "LinkedField",
            "name": "teamMember",
            "plural": false,
            "selections": [
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TaskFooterIntegrateMenuQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": "assigneeTeamMember",
            "args": (v3/*: any*/),
            "concreteType": "TeamMember",
            "kind": "LinkedField",
            "name": "teamMember",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": (v5/*: any*/),
                "concreteType": "RepoIntegrationQueryPayload",
                "kind": "LinkedField",
                "name": "prevUsedRepoIntegrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "prevUsedRepoIntegrations(first:1)"
              },
              (v11/*: any*/),
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "viewerTeamMember",
            "args": (v7/*: any*/),
            "concreteType": "TeamMember",
            "kind": "LinkedField",
            "name": "teamMember",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "q_HsA-GdoZhtqkmCE2BVi8Dg",
    "metadata": {},
    "name": "TaskFooterIntegrateMenuQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node ).hash = "cf0121c3994bc53096961e7e9aad58d3";

export default node;
